/**
 * Curated collection of food-related Unsplash photos used as temporary
 * meal card images on the menu page.
 *
 * TODO(#menu-images): Replace with real menu item images once menu-specific
 * image upload / association is implemented. Each meal card should display
 * the actual dish photo rather than a stock approximation.
 *
 * Design intent (BRD §3.4): photos used sparingly — only as blurred hero
 * imagery or these small meal-card thumbnails. These are NOT stored locally;
 * they load directly from the Unsplash CDN on every render.
 *
 * Each photo has been verified serving a 200 at time of writing.
 * If images break, replace IDs with fresh Unsplash food photo IDs.
 */

const FOOD_PHOTO_IDS: string[] = [
  "1490645935967-10de6ba17061", // bowls — grain bowls
  "1466637574441-749b8f19452f", // veg market — fresh produce
  "1505253758473-96b7015fcd40", // ingredients — cooking prep
  "1512621776951-a57141f2eefd", // greens — salad
  "1543339308-43e59d6b73a6", // spread — mezze / tapas
  "1567620905732-2d1ec7ab7445", // salad bowl — healthy bowl
  "1540189549336-e6e99c3679fe", // noodles — Asian noodles
];

/**
 * Simple string hash for deterministic index selection.
 */
function hashString(s: string): number {
  let hash = 0;
  for (let i = 0; i < s.length; i++) {
    hash = (Math.imul(31, hash) + s.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
}

/**
 * Return a deterministic food stock-photo URL for the given recipe slug.
 *
 * Each recipe slug always maps to the same Unsplash photo, so the image
 * is stable across renders and sessions.
 *
 * @param slug - Unique recipe identifier (e.g. `"poulet-rot"`).
 * @param width  - Desired image width in pixels (default 140).
 * @param height - Desired image height in pixels (default 140).
 */
export function getFoodImageUrl(
  slug: string,
  width = 140,
  height = 140,
): string {
  const idx = hashString(slug) % FOOD_PHOTO_IDS.length;
  const id = FOOD_PHOTO_IDS[idx];
  return `https://images.unsplash.com/photo-${id}?w=${width}&h=${height}&fit=crop&q=65&auto=format`;
}
